import React, { useState } from 'react';
import ReactTable from 'react-table';
import { Card, CardFooter, CardHeader, Collapse } from 'reactstrap';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

const column1 = [
  {
    Header: 'Date',
    accessor: 'commentTs',
  },
  {
    Header: 'Commenter',
    accessor: 'email',
  },
  {
    Header: 'Comment',
    accessor: 'comment',
    Cell: cellProps => (
      <div>
        <Tooltip title={cellProps.value} placement="left" color="#ff7142"/* overlayInnerStyle={{ width: '600px' }} */>{cellProps.value}</Tooltip>
      </div>
    ),
  },
];

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);
  const [showAddComment, setShowAddComment] = useState(false);
  const [disableSaveComment, setDisableSaveComment] = useState(true);

  const enableAddComment = () => {
    if (document.getElementById("tooling-gov-comment").value.length > 5) {
      setDisableSaveComment(false)
    }
  }

  const toggleShowAddComment = () => {
    if (showAddComment) setDisableSaveComment(true);
    setShowAddComment(!showAddComment);
  }

  const reactTableStyle = {
    textAlign: "left"
  }

  const reactTableRowStyle = {
    minWidth: "300px"
  }

  const reactTableCellStyle = {
    flex: "100 0 auto",
    width: "100px"
  }

  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          Government Comments (Only visible to other Government Users and ICON Staff) {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block.length > 0 ? data.block.length : 2}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
        {showAddComment &&
          <div className="ReactTable" style={reactTableStyle}>
            <div className="rt-table" role="grid">
              <div className="rt-thead -header" style={reactTableRowStyle}>
                <div className="rt-tr" role="row">
                  <div className="rt-th rt-resizable-header -cursor-pointer" role="columnheader" style={reactTableCellStyle}>
                    <div className="rt-resizable-header-content">Date</div>
                    <div className="rt-resizer" />
                  </div>
                  <div className="rt-th rt-resizable-header -cursor-pointer" role="columnheader" style={reactTableCellStyle}>
                    <div className="rt-resizable-header-content">Commenter</div>
                    <div className="rt-resizer" />
                  </div>
                  <div className="rt-th rt-resizable-header -cursor-pointer" role="columnheader" style={reactTableCellStyle}>
                    <div className="rt-resizable-header-content">Comment</div>
                    <div className="rt-resizer" />
                  </div>
                </div>
              </div>
              <div className="rt-tbody" style={reactTableRowStyle}>
                <div className="rt-tr-group" role="rowgroup">
                  <div className="rt-tr -odd" role="row">
                    <div className="rt-td" role="gridcell" style={reactTableCellStyle}>Date inserted when saved</div>
                    <div className="rt-td" role="gridcell" style={reactTableCellStyle}>{data.auth.email}</div>
                    <div className="rt-td" role="gridcell" style={reactTableCellStyle}>
                      <textarea rows={3} maxLength={1000} id="tooling-gov-comment" placeholder="Add DLA Comments" onChange={enableAddComment} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <CardFooter>
          <Button style={{ 'margin-left': 3 }} id='btn-tool-comment-add'
            className="floating-back"
            onClick={toggleShowAddComment}
          >
            {showAddComment ? "Discard New Tool Comment" : "Add Tool Comment"}
          </Button>

          {showAddComment && <Button style={{ 'margin-left': 3 }} id='btn-tool-comment-save'
            className="floating-back"
            onClick={data.addToolinCommentGov}
            disabled={disableSaveComment}
          >
            Save New Tool Comment
          </Button>
          }
        </CardFooter>
      </Card>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/ToolingCommentsGov.jsx